module.exports = vendorComponents;